import { jsx as c, jsxs as _, Fragment as P } from "react/jsx-runtime";
import { createContext as h, useContext as u, useState as E, useEffect as w, isValidElement as R, memo as x, useMemo as j } from "react";
import { createEventEmitter as T } from "@made-people/grease-event-emitter";
import { loadStoryblokBridge as F, storyblokEditable as $ } from "@storyblok/js";
import { isValidElementType as m, isForwardRef as b } from "react-is";
import { flattener as B } from "@made-people/flatten-object";
import { z as k } from "zod";
import { withZod as D } from "@made-people/react-prop-guard";
import { traverseAndReplace as L } from "@made-people/functions-traverse-and-replace";
function ro(o) {
  return [
    "_storyblok",
    "_storyblok_c",
    "_storyblok_lang",
    "_storyblok_release",
    "_storyblok_rl",
    "_storyblok_tk[space_id]",
    "_storyblok_tk[timestamp]",
    "_storyblok_tk[token]"
  ].every((t) => o.has(t));
}
const C = h(void 0), I = (o) => /* @__PURE__ */ c(C.Provider, { value: o, children: o.children });
I.displayName = "StoryblokComponentProvider";
const V = () => {
  const o = u(C);
  if (o === void 0)
    throw new Error(
      "useStoryblokComponentTransformers must be used within a StoryblokComponentProvider"
    );
  return o.transformers;
}, A = T();
async function N(o, t, e, s) {
  var r;
  if (o.action === "input" && ((r = o.story) == null ? void 0 : r.id) === e.id) {
    const n = await s(o.story);
    n && (t(n), A.emit("storyUpdated", n));
  } else
    ["change", "published"].includes(o.action) && o.storyId === e.id && window.location.reload();
}
const no = ({
  children: o,
  ...t
}) => /* @__PURE__ */ c("span", { ...t, children: o }), p = h(
  void 0
), H = (o) => {
  const [t, e] = E(null);
  w(() => {
    e(null);
  }, [o.story.id]);
  const s = (n) => {
    e((i) => {
      const d = i ?? o.story;
      return typeof n == "function" ? n(d) : n;
    });
  }, r = {
    story: t ?? o.story,
    setStory: s,
    insideStoryblokPreview: o.insideStoryblokPreview
  };
  return /* @__PURE__ */ _(p.Provider, { value: r, children: [
    o.insideStoryblokPreview && o.previewStoryResolver && /* @__PURE__ */ c(
      q,
      {
        originalStory: o.story,
        previewStoryResolver: o.previewStoryResolver
      }
    ),
    o.children
  ] });
};
H.displayName = "StoryblokStoryProvider";
const U = () => {
  const o = u(p);
  if (!o)
    throw new Error(
      "useStoryblokStory must be used inside StoryblokStoryProvider"
    );
  return o;
}, W = () => {
  const o = u(p);
  if (!o)
    throw new Error(
      "useInsideStoryblokPreview must be used inside StoryblokStoryProvider"
    );
  return o.insideStoryblokPreview;
}, q = (o) => {
  const { setStory: t } = U();
  return w(() => {
    F().then(() => {
      window.storyblokRegisterEvent(() => {
        new window.StoryblokBridge().on(["input", "published", "change"], (s) => {
          s && N(
            s,
            t,
            o.originalStory,
            o.previewStoryResolver
          ).catch((r) => console.error("Error in storyblokEventHandler", r));
        });
      });
    });
  }), null;
};
let l = {}, a = {}, y = {}, f = {};
const z = (o) => l[o] ? l[o] : (console.error(`Component ${o} doesn't exist.`), !1), so = (o) => {
  a = {};
  for (const [t, e] of Object.entries(o)) {
    if (!m(e)) {
      console.warn(
        `[registerStoryblokComponents]: invalid input for component ${t}: `,
        e
      );
      continue;
    }
    a[t] = e;
  }
  l = {
    ...y ?? {},
    ...a ?? {},
    ...f ?? {}
  };
};
function io(o, t, e) {
  let s = y;
  if ((typeof o != "string" && t === !0 || e === !0) && (s = f), typeof o == "string") {
    const r = o, n = t;
    if (m(n))
      b(n) || console.warn(
        `[addStoryblokComponents]: Component ${r} is not wrapped with "React.forwardRef"? Please do so and set the ref on an html element for Storyblok preview to work correctly`
      );
    else {
      console.warn(
        `[addStoryblokComponents]: invalid input for component ${r}: `,
        n
      );
      return;
    }
    if (r in l && typeof l[r] < "u") {
      console.warn(
        `[addStoryblokComponents]: Component ${r} is already registered`
      );
      return;
    }
    s[r] = n;
  } else {
    if (typeof o != "object" || o === null) {
      console.warn(
        "[addStoryblokComponents]: invalid input, got: ",
        o
      );
      return;
    }
    for (const [r, n] of Object.entries(o)) {
      if (m(n))
        b(n) || console.warn(
          `[addStoryblokComponents]: Component ${r} is not wrapped with "React.forwardRef"? Please do so and set the ref on an html element for Storyblok preview to work correctly`
        );
      else {
        console.warn(
          `[addStoryblokComponents]: invalid input for component ${r}: `,
          n
        );
        continue;
      }
      if (r in l && typeof l[r] < "u") {
        console.warn(
          `[addStoryblokComponents]: Component ${r} is already registered`
        );
        continue;
      }
      s[r] = n;
    }
  }
  l = {
    ...y ?? {},
    ...a ?? {},
    ...f ?? {}
  };
}
function lo() {
  l = {}, a = {}, y = {}, f = {};
}
function v(o, t, e) {
  if (!o.component)
    return console.error("Key `component' doesn't exist on the Storyblok data", o), null;
  const s = e || o._uid;
  let r;
  typeof t == "function" ? t != null && t(o) ? r = !0 : r = !1 : r = t;
  const n = z(o.component);
  if (n)
    if (r) {
      const i = $(o);
      return /* @__PURE__ */ c(
        "div",
        {
          style: { display: "contents" },
          "data-blok-c": i["data-blok-c"],
          "data-blok-uid": i["data-blok-uid"],
          children: /* @__PURE__ */ c(n, { ...o })
        },
        s
      );
    } else
      return /* @__PURE__ */ c(n, { ...o }, s);
  return null;
}
class co {
  constructor(t, e) {
    this.childrenField = t, this.insideStoryblokPreview = e;
  }
  transform(t) {
    const e = t[this.childrenField];
    return this.isStoryblokChildren(e) ? {
      ...t,
      [this.childrenField]: e.map(
        (s, r) => v(s, this.insideStoryblokPreview)
      )
    } : t;
  }
  /**
   * Check if the blok's children field is an array of objects with
   * a component field, which means they are Storyblok components.
   */
  shouldTransform(t) {
    const e = t[this.childrenField];
    return this.isStoryblokChildren(e);
  }
  /**
   * Guard to use in TypeScript to check if the children field is an array
   * of Storyblok components.
   */
  isStoryblokChildren(t) {
    return !!(t && Array.isArray(t) && t.every(
      (e) => typeof e == "object" && typeof e.component == "string"
    ));
  }
}
class ao {
  constructor(t, e) {
    this.replacer = t, this.matcher = e;
  }
  transform(t) {
    return this.replacer(t);
  }
  shouldTransform(t) {
    return this.matcher(t);
  }
}
class yo {
  constructor(t) {
    this.fieldDelimiter = t;
  }
  transform(t) {
    const e = new RegExp(`^${this.fieldDelimiter}`);
    return B(this.fieldDelimiter, {
      skipUnflatten: (r) => e.test(r)
    }).unflatten(t);
  }
  shouldTransform(t) {
    return !0;
  }
}
function S(o, t) {
  return !!(Object.getOwnPropertyDescriptor(o, t) || {}).writable;
}
function O(o) {
  var t;
  return !!((t = o == null ? void 0 : o.props) != null && t.hasOwnProperty("children"));
}
function Q(o, t) {
  function e(s, r) {
    return L(
      s,
      (n) => {
        let i = n;
        return r.shouldTransform(i) && (i = r.transform(i)), O(i) ? (S(i, "props") || (i = { ...i, props: { ...i.props } }), i.props = e(i.props, r)) : typeof i == "object" && !R(i) && i !== null && Object.keys(i).forEach((d) => {
          S(i, d) && (i[d] = e(i[d], r));
        }), i;
      },
      (n) => typeof n == "object"
    );
  }
  for (const s of t)
    o = e(o, s);
  return o;
}
const g = x((o) => {
  const t = W(), e = V(), { blok: s } = o;
  return j(() => {
    const r = Q(s, e);
    return v(r, t);
  }, [s]);
});
g.displayName = "StoryblokComponent";
const Z = k.object({
  components: k.custom().array()
}), fo = D(
  Z,
  (o) => /* @__PURE__ */ c(P, { children: o.components.map((t, e) => /* @__PURE__ */ c(
    g,
    {
      blok: t
    },
    `storyblok-component-${e}`
  )) })
);
function mo(o) {
  return o !== null && typeof o == "object" && "component" in o && typeof o.component == "string" && "_uid" in o && typeof o._uid == "string" && "_editable" in o && typeof o._editable == "string";
}
export {
  co as StoryblokBlockListTransformer,
  g as StoryblokComponent,
  fo as StoryblokComponentList,
  I as StoryblokComponentProvider,
  ao as StoryblokContentReplaceTransformer,
  yo as StoryblokFieldDelimiterTransformer,
  no as StoryblokPreviewLink,
  q as StoryblokPreviewListener,
  H as StoryblokStoryProvider,
  io as addStoryblokComponents,
  lo as clearStoryblokComponents,
  z as getStoryblokComponent,
  mo as isStoryblokComponentObject,
  ro as isStoryblokPreviewRequestQuery,
  Q as recursiveReplace,
  so as registerStoryblokComponents,
  Z as storyblokComponentListSchema,
  v as storyblokComponentToReactElement,
  A as storyblokEventEmitter,
  N as storyblokEventHandler,
  W as useInsideStoryblokPreview,
  V as useStoryblokComponentTransformers,
  U as useStoryblokStory
};
